import { createContext, useContext } from 'react'

export const RefreshSignalContext = createContext({ 
  refreshTrigger: 0, 
  triggerRefresh: () => {} 
})

export const useRefreshSignal = () => {
  return useContext(RefreshSignalContext)
}
